import React from 'react';
import { rageLoggerContent } from '../rich-content/rage-logger-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const RageLoggerDetailPage = () => {
  return <AutomaticPageBuilder content={rageLoggerContent} />;
};

export default RageLoggerDetailPage;
